<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="epi">
<div class="block">
<p class="nonindent">“But dreadful is the mysterious<br/>power of fate; there is no<br/>deliverance from it by wealth or by war, by<br/>fenced city, or dark, sea-<br/>beaten ships.”</p>
<p class="right">Chorus, <em>Antigone</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795335020_epi.vue?158a069c